<script setup>
import pluralize from 'pluralize'
import useCloudflareImage from '../../../Composables/useCloudflareImage.js'

const { cloudflareImage } = useCloudflareImage()

defineProps({
    course: Object
})
</script>

<template>
<div class="bg-[rgba(20,22,57,1)] p-6 md:p-10 rounded-2xl relative after:absolute after:bg-contain after:bg-[url('/images/light-circle.svg')] after:-left-[300px] after:-top-[300px] after:w-[800px] after:h-[800px] after:z-1 after:pointer-events-none overflow-hidden">
    <div v-if="!course.upcoming" class="inline-flex items-center space-x-3 text-sm text-[rgba(169,198,249,1)] bg-gradient-to-r from-[rgba(44,50,112,1)] to-[rgba(44,50,112,0.3)] leading-none py-3.5 px-4 pr-6 font-medium border-l-[4px] border-[rgba(73,126,229,1)] rounded-r-lg mb-8">
        <span>{{ pluralize('episode', course.parts_count, true) }}</span>
        <span>&bull;</span>
        <span><template v-if="course.duration.formatted.hours">{{ course.duration.formatted.hours }} {{ pluralize('hr', course.duration.formatted.hours) }} </template> {{ course.duration.formatted.minutes }} {{ pluralize('min', course.duration.formatted.minutes) }}</span>
        <span class="hidden sm:inline">&bull;</span>
        <span class="hidden sm:inline">{{ course.created_at.human }}</span>
    </div>

    <div>
        <h2 class="text-xl font-semibold bg-gradient-to-r to-[rgba(137,128,245,1)] from-[rgba(255,200,255,1)] text-transparent bg-clip-text leading-none">
            Overview
        </h2>
        <div class="mt-6 text-[rgba(233,232,255,1)] font-medium prose prose-sm prose-default prose-li:marker:text-[rgba(112,120,176,0.7)] prose-li:marker:font-semibold max-w-fit" v-html="course.description_markdown"></div>
    </div>

    <div class="flex items-center space-x-5 mt-10" v-if="course.author">
        <img :src="cloudflareImage(course.author.avatar, { width: 200, height: 200 })" loading="lazy" class="size-12 md:size-14 rounded-full" :alt="course.author.name">
        <div>
            <div class="text-base md:text-lg font-semibold bg-gradient-to-r from-[rgba(255,200,255,1)] to-[rgba(137,128,245,1)] text-transparent bg-clip-text leading-tight">
                {{ course.author.name }}
            </div>
            <div class="text-sm text-[rgba(233,232,255,0.8)] font-medium mt-1">
                {{ course.author.bio }}
            </div>
        </div>
    </div>
</div>
</template>
